import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

/**
 * PasswordInput — Iteration 300. Password field with an inline eye toggle.
 * Tap targets are ≥44x44px for mobile; aria-label flips between
 * "Show password" / "Hide password"; icon swaps Eye ⇄ EyeOff.
 * All other props (value, onChange, placeholder, data-testid…) pass
 * straight through to the underlying <input>.
 */
export default function PasswordInput({ toggleTestId, className = "", ...props }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input
        {...props}
        type={show ? "text" : "password"}
        className={`${className} pr-12`}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        aria-label={show ? "Hide password" : "Show password"}
        aria-pressed={show}
        data-testid={toggleTestId}
        className="absolute right-0 top-0 h-full w-11 min-w-[44px] min-h-[44px] inline-flex items-center justify-center text-slate-400 hover:text-slate-700 transition"
      >
        {show ? <Eye className="w-4 h-4" data-testid={toggleTestId ? `${toggleTestId}-icon-visible` : undefined} /> : <EyeOff className="w-4 h-4" data-testid={toggleTestId ? `${toggleTestId}-icon-hidden` : undefined} />}
      </button>
    </div>
  );
}
